import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, TouchableHighlight, View } from 'react-native';

import { Theme } from '@constants';

import { TWCTile } from '../../focusable/TWCTile/TWCTile';
import { TWCText } from '../../primitives/TWCText/TWCText';

export const ANFTileLayout = {
  width: 320,
  height: 180,
};

const tPath = 'videoControls';

type ANFTileProps = {
  title: string;
  description: string;
  selected?: boolean;
};

type ANFTileRef = View | TouchableHighlight;

export const ANFTile = forwardRef<ANFTileRef, ANFTileProps>(
  ({ title, description, selected, ...properties }, reference) => {
    const { t } = useTranslation('translation', { keyPrefix: tPath });

    return (
      <TWCTile
        {...properties}
        gradientType="anfTile"
        height={180}
        ref={reference}
        shouldUseContextReference={false}
        testID="tile"
        width={320}
      >
        <View style={[styles.watchingContainer, selected && styles.watching]}>
          {selected ? (
            <TWCText noTestID fontFamily="medium" style={styles.watchingText}>
              {t('watching')}
            </TWCText>
          ) : null}
        </View>
        <View style={styles.wrapper}>
          <Text ellipsizeMode="clip" numberOfLines={2} style={styles.allTitle} testID="outer">
            <TWCText ellipsizeMode="clip" style={styles.title} testID="inner" variant="anfTileTitle">
              {title}
            </TWCText>
          </Text>
          <TWCText numberOfLines={2} style={styles.location} testID="location" variant="boldText24">
            {description}
          </TWCText>
        </View>
      </TWCTile>
    );
  },
);

const styles = StyleSheet.create({
  allTitle: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Black',
    fontSize: Theme.px(24),
  },
  location: {
    paddingLeft: Theme.px(12),
    paddingTop: Theme.px(3),
  },
  title: {
    backgroundColor: Theme.red,
  },
  watching: {
    backgroundColor: Theme.enabledColor,
    borderRadius: Theme.px(6),
    paddingHorizontal: Theme.px(6),
    paddingVertical: Theme.px(2),
  },
  watchingContainer: {
    height: Theme.px(34),
    marginLeft: Theme.px(30),
    marginTop: Theme.px(12),
    width: Theme.px(104),
  },
  watchingText: {
    color: Theme.black,
    fontSize: Theme.px(21),
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginLeft: Theme.px(29),
    marginRight: Theme.px(29),
    marginTop: Theme.px(13),
  },
});
